// Biblioteca de animações da composição Reels (editData.graphics).
//
// Um MotionGraphic = { id, template, start, end, zone: 'top'|'middle', props }. A IA
// (backend/src/services/videoEdit/graphicsPlanner.ts) escolhe template + props + tempo;
// o usuário edita na aba Final. Antes de desenhar, TUDO passa por validateGraphic().
//
// Props por template (schema completo e limites em ./schema.ts — GRAPHIC_SPECS):
//   counter        { value: number, prefix?: string(≤6), suffix?: string(≤8), label?: string(≤40), decimals?: 0|1|2 }
//   checklist      { items: string[] (1–4, ≤30 cada), title?: string(≤28) }
//   typewriter     { text: string(≤90), title?: string(≤20) }
//   timeline       { steps: string[] (2–4, ≤16 cada) }
//   arrow_callout  { label: string(≤24), x: 0.08–0.92, y: 0.12–0.85 (ALVO), direction: 'up'|'down'|'left'|'right' (para onde aponta) }
//   compare_bars   { left: {label(≤16), value≥0}, right: {label, value}, unit?: string(≤6) ("%", "h", "R$"…), title?: string(≤28) }
//   keyword_pop    { word: string(≤18), sub?: string(≤36) }
//   steps          { items: string[] (1–3, ≤34 cada) }
// Todos aceitam accent?: '#rrggbb' (vazio = captions.accent → hook.accent do vídeo).
//
// Zonas (1080×1920): top = conteúdo a partir de y≈210 (11%), o hook é dono do topo até
// hook.endSec (o planner garante start ≥ hookEndSec); middle = centrado em y≈864 (35–55%).
// A legenda mora no terço de baixo. arrow_callout se posiciona pelo alvo e ignora a zona.
import type React from 'react';
import type { GraphicComponentProps } from './common';
import type { GraphicTemplateId } from './schema';
import { Counter } from './Counter';
import { Checklist } from './Checklist';
import { Typewriter } from './Typewriter';
import { Timeline } from './Timeline';
import { ArrowCallout } from './ArrowCallout';
import { CompareBars } from './CompareBars';
import { KeywordPop } from './KeywordPop';
import { Steps } from './Steps';

export * from './schema';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GRAPHIC_COMPONENTS: Record<GraphicTemplateId, React.FC<GraphicComponentProps<any>>> = {
  counter: Counter,
  checklist: Checklist,
  typewriter: Typewriter,
  timeline: Timeline,
  arrow_callout: ArrowCallout,
  compare_bars: CompareBars,
  keyword_pop: KeywordPop,
  steps: Steps,
};

export type { GraphicComponentProps } from './common';
export { ZONE_TOP_Y, ZONE_MIDDLE_Y, SAFE_W } from './common';
